<template lang="pug">
  div
    .space-y-8
      .z-20.relative.anim-fade-up(v-if="tags.length > 1")
        h4.font-bold.mb-2 Motif de consultation
        tag-select(
          :selected_tag="selected_tag"
          :tags="tags"
          @change="value = $event"
        )

      .anim-fade-up
        h4.font-bold.mb-4 Choix du créneau horaire
        .tab-appointment.text-center.text-sm
          .relative
            .tab-appointment__nav.absolute.w-full.text-white.flex.justify-between.px-2.pt-4
              i.fal.fa-chevron-left(@click="goToPreviousWeek", v-if="new Date(this.date).setHours(0,0,0,0) > (new Date).setHours(0,0,0,0)")
              i(v-else)
              i.fal.fa-chevron-right(@click="goToNextWeek")

            .tab-appointment__wrapper.w-full
              .flex
                .bg-primary.text-sm.text-white.leading-tight.py-4.px-4(class="w-1/4" v-for="(day, index) in schedules")
                  p {{ new Date(index).toLocaleDateString('fr-FR', {weekday: 'short'}) }}
                  p {{ new Date(index).toLocaleDateString('fr-FR', {day: 'numeric', month: 'short'}) }}

              .tab-appointment__container.flex.overflow-auto(:class="{ active: !isOpen }")
                div(class="w-1/4" v-for="(day, index) in schedules")
                  div(v-if="Object.keys(value).length !== 0 && practitioner_office.tags_available_online")
                    .space-y-4.py-2(v-if="day[0] && day[0].table && day[0].table.time_slots.length > 0")
                      template(v-for="time_slot in day")
                        a(
                          href="#",
                          v-bind:class="{ 'bg-info-100': !time_slot.table.is_home_care, 'bg-info-200': time_slot.table.is_home_care }"
                          class="block text-white leading-none py-2 w-9/12 mx-auto rounded transition duration-300 hover:opacity-25 relative"
                          v-if="sub_time_slot !== undefined"
                          v-for="sub_time_slot in time_slot.table.time_slots"
                          @click="submitOrOpenModal(sub_time_slot)"
                        ) {{ new Date(sub_time_slot["appointment_time"]).toLocaleTimeString([], {timeZone: 'Europe/Paris', hour: '2-digit', minute:'2-digit'}) }}
                          .absolute.top-1.left-1.h-2.w-2.rounded-full.bg-yellow(v-if="time_slot.table.substitute_practitioner")

              div(v-show="displayOpenCalendar")
                p.mt-3.uppercase.text-primary.font-bold.underline.cursor-pointer(@click="isOpen = !isOpen" v-show="!isOpen" type="button") Voir les autres horaires
                p.mt-3.uppercase.text-primary.font-bold.underline.cursor-pointer(@click="isOpen = !isOpen" v-show="isOpen" type="button") Réduire

          .h-72.w-full(v-if="Object.keys(value).length == 0")
            .bg-gray-100.h-full.w-full.flex.flex-col.justify-center.items-center.border-b.border-l.border-r.border-gray-100.rounded-b
              span(
                class="font-bold font-bold relative z-20"
              ) Veuillez choisir un motif pour voir les horaires

          .h-72.w-full(v-else-if="(!practitioner_office.has_future_availabilities && practitioner_office.phone) || !practitioner_office.tags_available_online")
            .relative.h-full.w-full.flex.flex-col.justify-center.items-center.border-b.border-l.border-r.border-gray-100.rounded-b
              .absolute.top-0.left-0.right-0.bottom-0.w-full.h-full.bg-gray-50.opacity-25.z-10
              a(
                :href="'tel:'+practitioner_office.phone",
                class="link link-primary relative z-20 group relative"
              ) Appeler pour prendre rendez-vous
                .h-px.w-full.absolute.-bottom-1.left-0.right-0.bg-primary.transition-all.duration-300.ease-in-out(class="group-hover:w-0")

          .h-72.w-full(v-else-if="next_range_availability_date")
            .bg-gray-50.h-full.w-full.flex.flex-col.justify-center.items-center.border-b.border-l.border-r.border-gray-100.rounded-b
              a(
                h-ref="#",
                class="link link-primary relative z-20 group relative"
                @click="goToNextAvailability"
              ) Prochaine disponibilité le {{ new Date(next_range_availability_date).toLocaleDateString('fr-FR', {day: 'numeric', month: 'short'}) }}
                .h-px.w-full.absolute.-bottom-1.left-0.right-0.bg-primary.transition-all.duration-300.ease-in-out(class="group-hover:w-0")

          .h-72.w-full(v-else-if="empty_timeslots")
            .bg-gray-50.h-full.w-full.flex.flex-col.justify-center.items-center.border-b.border-l.border-r.border-gray-100.rounded-b
              span(
                class="font-bold font-bold relative z-20"
              ) Aucune disponibilité pour cette semaine

      .anim-fade-up.text-sm(v-if="Object.keys(value).length !== 0")
        .flex.items-center.justify-between
          .flex.items-center.space-x-4
            .flex.items-center(v-if="practitioner_office.has_future_and_home_care_range_availabilities")
              .h-6.w-6.bg-info-100.rounded-sm.mr-2
              p.leading-none Cabinet
            .flex.items-center(v-if="practitioner_office.has_future_and_home_care_range_availabilities")
              .h-6.w-6.bg-info-200.rounded-sm.mr-2
              p.leading-none A domicile

          .flex.items-center
            p.leading-none Fuseau horaire : {{ practitioner_office.time_zone }}

        .flex.items-center.mt-2(v-if="any_substitute_practitioner")
          .h-4.w-4.rounded-full.bg-yellow.mr-2
          p.leading-none Consultation assurée par un(e) remplaçant(e)

    modal(ref="infoModal")
      template(v-slot:body)
        p.text-xl.leading-none.text-primary.font-bold.my-4 ATTENTION, à lire avant de prendre un rendez-vous
        .wysiwyg-wrapper__practitionners
          p {{ practitioner_office.info_message }}

        .pt-6.space-x-3.flex.justify-center.items-center(class="lg:pt-6")
          button(
            @click="$refs.infoModal.closeModal()"
            class='btn-outline btn-lg text-lg btn-outline-primary px-12'
          ) Annuler

          button(
            @click="submit()"
            class='btn btn-lg btn-secondary text-lg font-bold px-12'
          ) J'accepte

</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: {
    practitioner_office: {
      type: Object,
      default: () => ({})
    },

    selected_tag: {
      type: Object,
      default: () => ({})
    },

    tags: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      isOpen: false,
      displayOpenCalendar: false,
      value: this.selected_tag,
      schedules: [],
      date: new Date,
      next_range_availability_date: '',
      empty_timeslots: false,
      any_substitute_practitioner: false,
      appointment_url: ''
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: 'updateSchedule'
    },
    date: 'updateSchedule'
  },

  methods: {
    submitOrOpenModal(time_slot) {
      this.appointment_url = time_slot.appointment_url

      if (this.practitioner_office.info_message) {
        this.$refs.infoModal.openModal()
      } else {
        this.submit()
      }
    },

    submit() {
      window.location.replace(this.appointment_url);
    },

    goToNextWeek () {
      this.date = new Date(this.date.setDate(this.date.getDate() + 4))
    },

    goToPreviousWeek () {
      const current_date_to_compare = new Date(this.date)
      if (new Date(this.date).setHours(0,0,0,0) > (new Date).setHours(0,0,0,0)) {
        this.date = new Date(this.date.setDate(this.date.getDate() - 4))
      }
    },

    goToNextAvailability () {
      this.date = new Date(this.next_range_availability_date)
    },

    updateSchedule () {
      const tag = this.value
      const practitioner_office = this.$props.practitioner_office

      axios.get(`/practitioner_offices/${practitioner_office.id}/schedules`, {
        params: {
          tag_id: tag.value,
          start_at: this.date
        }
      })
      .then(({ data }) => {
        this.displayOpenCalendar = data.table.nb_slots_max > 5
        this.schedules = data.table.days
        this.next_range_availability_date = data.table.next_range_availability_date
        this.empty_timeslots = data.table.empty_timeslots
        this.any_substitute_practitioner = data.table.any_substitute_practitioner
      })
    }
  }
}
</script>
